/**
 * @file 自定义筛选项hooks
 * @author alfielv
 */

import _ from 'lodash';
import React, { useState } from 'react';
import { Icon } from '@tencent/spaui';
import { hooks } from '@tencent/ptp-fe-common';

const { useCustomColumn } = hooks;
// "更多筛选项"触发组件
const TriggerComponent = () => (
  <div className="button-filter-add">
    <Icon type='add' />
    <span className="spaui-text">自定义筛选项</span>
  </div>
);

// 获取筛选项的自定义列cellConfig格式
const customFiltersConfig = (filterControls = {}) => {
  // 数组结构controls，直接返回扁平化配置
  if (_.isArray(filterControls)) {
    return {
      default: {
        name: '自定义筛选项',
        list: [
          {
            name: '基础配置',
            columns: _.map(filterControls, (opt) => ({
              displayName: opt.title,
              name: opt.key || opt.name,
            })),
          },
        ],
      },
    };
  }
  // 否则层级结构化
  const formatList = (list) =>
    _.map(list, (item) => ({
      name: item.key || item.name,
      ...(item.filters
        ? {
          columns: _.map(item.filters, ({ key, title, name }) => ({
            displayName: title,
            name: key || name,
          })),
        }
        : {
          list: formatList(item.list),
        }),
    }));

  return {
    default: {
      name: '自定义筛选项',
      list: formatList(_.values(filterControls)),
    },
  };
};

const getDefaultCustomConfigure = (key) => {
  let arr = [];
  try {
    arr = JSON.parse(localStorage.getItem(key));
  } catch (error) {
    console.log('本地自定义筛选配置读取失败');
  }
  if (Array.isArray(arr)) return arr;
  return [];
};

export default (props) => {
  const {
    // 用作持久化存储筛选项的唯一key
    storageKey = `ams:user_profile:advertiser_custom_filters_${window.location.pathname}`,
    controls,
    defaultFilterKeys,
    dropMenuTriggerProps,
  } = props;

  // 远程数据加载状态
  const [fetchLoading, setFetchLoading] = useState(false);
  // 远程自定义配置集合
  const [originConfigureList, setOriginConfigureList] = useState(getDefaultCustomConfigure(storageKey));
  // 本地自定义配置
  const [localConfigure, setLocalConfigure] = useState([]);
  // 当前选中的自定义列配置名
  const [activeConfigureName, setActiveConfigureName] = useState('');

  const saveCustomConfigure = configArr => {
    const arr = configArr.filter(Boolean);
    localStorage.setItem(storageKey, JSON.stringify(arr));
    setOriginConfigureList(arr);
  };

  const configureDataSource = {
    fetchLoading,
    localConfigure,
    updateLocalConfigure: setLocalConfigure,
    originConfigureList,
    updateOriginConfigureList: saveCustomConfigure,
    activeConfigureName,
    updateActiveConfigureName: setActiveConfigureName,
  };

  const { loading, selectedColumns, customColumnComponent: customFilterComponent } = useCustomColumn({
    configureDataSource,
    columnsDefs: {
      cellsConfig: customFiltersConfig(controls),
      dropMenuTriggerComponent: <TriggerComponent />,
      dropMenuTriggerProps,
      dropMenuProps: {
        title: '常用筛选项',
      },
      columnsProps: {
        dialogProps: {
          modalClassName: 'custom-filter-control-dialog',
          headerAdditionalContent: <h4 className="modal-title-filter">自定义筛选项</h4>,
        },
        storableLabel: '保存为常用筛选项',
        hideFixedTipComponent: true,
        defaultStorageData: {
          checked: false,
          storageName: '自定义筛选项',
        },
      },
    },
    // 作为自定义筛选项，只使用unfixed。
    defaultSelectedColumns: {
      unmovableCells: ['startActionDate'],
      fixed: [],
      unfixed: defaultFilterKeys.filter(k => k !== 'startActionDate'),
    },
  });

  return {
    loading, // 自定义筛选项加载状态
    activeFilterKeys: ['startActionDate', ..._.get(selectedColumns, 'unfixed', [])], // 显示的筛选项keys
    customFilterComponent, // 自定义筛选项组件
  };
};
